module.exports = __webpack_public_path__ + "img/office1_7-8-2021.f5dffd3f.jpg";